import moment from "moment";

export function isValidateNextParoleDateFormat(dateString: string) {
  // Check if the date string matches the MM/YYYY format
  return moment(dateString, "MM/YYYY", true)?.isValid();
}
